module.exports = __webpack_public_path__ + "static/Facebook Live Icon-e2759c0b4e8e723d844b5bd1d2bfd993.png";